import { render, staticRenderFns } from "./MethodPayment.vue?vue&type=template&id=5155454e&scoped=true"
import script from "./MethodPayment.vue?vue&type=script&lang=js"
export * from "./MethodPayment.vue?vue&type=script&lang=js"
import style0 from "./MethodPayment.vue?vue&type=style&index=0&id=5155454e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5155454e",
  null
  
)

export default component.exports